<template>
  <DatePicker
    color="gray"
    title-position="right"
    v-model="range"
    is-range
  >
    <template v-slot="{ inputValue, inputEvents }">
      <div class="relative">
        <CalendarIcon
          class="top-2.5 left-3 h-4 w-4 text-blue-600 absolute"
          aria-hidden="true"
        />
        <input
          type="text"
          class="pl-8"
          :value="computeInputValue(inputValue)"
          v-on="inputEvents.start"
        />
      </div>
    </template>
  </DatePicker>
</template>

<script>
import { DatePicker } from 'v-calendar'
import { CalendarIcon } from '@heroicons/vue/solid'
import moment from 'moment'

export default {
  props: {
    /**
     * A string date (year, month, date).
     */
    start: {
      type: String,
      default: null,
      required: true
    },
    /**
     * A string date (year, month, date).
     */
    end: {
      type: String,
      default: null,
      required: true
    },
    dateFormat: {
      type: String,
      default: 'YYYY-MM-DD'
    }
  },

  emits: ['update:start', 'update:end'],

  components: {
    CalendarIcon,
    DatePicker
  },

  data() {
    return {
      range: {
        start: this.start ? moment(this.start).toDate() : new Date(),
        end: this.end ? moment(this.end).toDate() : new Date()
      }
    }
  },

  watch: {
    range(newVal) {
      this.update(newVal)
    }
  },

  methods: {
    /**
     * Emits a date (year, month, date) in established format for start and end model bindings.
     *
     * @param newVal
     */
    update(newVal) {
      this.$emit('update:start', moment(newVal.start).format(this.dateFormat))
      this.$emit('update:end', moment(newVal.end).format(this.dateFormat))
    },
    computeInputValue(inputValue) {
      return `${inputValue.start} - ${inputValue.end}`
    }
  }
}
</script>
